<header class="container">
    <div class="row">
        <div class="col-12 d-flex align-items-center justify-content-between">
            <!-- Logo -->
            <div class="d-flex align-items-center">
                <a routerLink="/" class="mt-logo-link" aria-label="MemberTrace home">
                    <img 
                        src="/img/membertrace-logo-color-300w.webp"
                        srcset="/img/membertrace-logo-color-300w.webp 300w,
                                /img/membertrace-logo-color-600w.webp 600w"
                        sizes="(max-width: 767px) 200px, 266px"
                        alt="MemberTrace Logo" 
                        class="mt-logo"
                        width="266"
                        height="32" />
                </a>
            </div>

            <!-- Desktop Navigation (lg and up; tablets use the mobile menu) -->
            <nav class="d-none d-lg-flex align-items-center gap-3" aria-label="Main navigation">
                <div class="nav-dropdown"
                     (mouseenter)="onCommunitiesEnter()"
                     (mouseleave)="onCommunitiesLeave()"
                     (focusin)="onCommunitiesEnter()"
                     (focusout)="onDropdownFocusOut($event, 'communities')">
                    <a class="mt-nav-link nav-dropdown-trigger"
                       routerLink="/communities"
                       [attr.aria-expanded]="communitiesOpen"
                       aria-haspopup="true">
                        Communities
                    </a>
                    <div class="nav-dropdown-panel" [class.open]="communitiesOpen" role="menu">
                        <a class="nav-dropdown-item" routerLink="/communities/medical-societies" role="menuitem">Medical &amp; Surgical Societies</a>
                        <a class="nav-dropdown-item" routerLink="/communities/physician-entrepreneurs" role="menuitem">Physician Entrepreneurs</a>
                        <div class="nav-dropdown-divider"></div>
                        <a class="nav-dropdown-item nav-dropdown-item-cta" routerLink="/start-a-community" role="menuitem">Start a Community</a>
                    </div>
                </div>
                <a class="mt-nav-link" routerLink="/pricing">Pricing</a>
                <div class="nav-dropdown"
                     (mouseenter)="onResourcesEnter()"
                     (mouseleave)="onResourcesLeave()"
                     (focusin)="onResourcesEnter()"
                     (focusout)="onDropdownFocusOut($event, 'resources')">
                    <a class="mt-nav-link nav-dropdown-trigger"
                       routerLink="/resources"
                       [attr.aria-expanded]="resourcesOpen"
                       aria-haspopup="true">
                        Resources
                    </a>
                    <div class="nav-dropdown-panel" [class.open]="resourcesOpen" role="menu">
                        <a class="nav-dropdown-item" routerLink="/resources" role="menuitem">Resources</a>
                        <a class="nav-dropdown-item" routerLink="/mobile" role="menuitem">Mobile app</a>
                        <a class="nav-dropdown-item" routerLink="/for-operators" role="menuitem">For operators</a>
                    </div>
                </div>
                <a class="mt-nav-link" routerLink="/contact">Contact</a>
                <div class="d-flex align-items-center gap-2">
                    <button mat-flat-button color="primary" class="mt-get-started" routerLink="/contact" [queryParams]="{ inquiryType: 'demo' }" (click)="onDemoCta()">Book a demo</button>
                </div>
            </nav>

            <!-- Mobile Menu Button -->
            <button class="mobile-menu-button d-lg-none" (click)="toggleMobileMenu()" aria-label="Toggle menu">
                <mat-icon>{{ isMobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
            </button>
        </div>
    </div>
</header>

<!-- Mobile overlay only when open — avoids WebKit hit-testing glitches on invisible fixed layers -->
<div
     *ngIf="isMobileMenuOpen"
     class="mobile-menu-overlay open"
     (click)="closeMobileMenu()"
     (keydown.escape)="closeMobileMenu()"
     aria-hidden="false"></div>

<!-- Mobile Menu -->
<nav class="mobile-menu" [class.open]="isMobileMenuOpen" aria-label="Mobile navigation">
    <!-- Exit Button -->
    <button class="mobile-menu-close" (click)="closeMobileMenu()" aria-label="Close menu">
        <mat-icon>close</mat-icon>
    </button>
    
    <div class="mobile-menu-content">
        <!-- Logo as Home Button -->
        <a class="mobile-menu-logo" routerLink="/" (click)="closeMobileMenu()" aria-label="Home">
            <img 
                src="/img/membertrace-logo-color-300w.webp"
                srcset="/img/membertrace-logo-color-300w.webp 300w,
                        /img/membertrace-logo-color-600w.webp 600w"
                sizes="200px"
                alt="MemberTrace Logo"
                width="266"
                height="32" />
        </a>
        
        <a class="mobile-nav-link" routerLink="/communities" (click)="closeMobileMenu()">Communities</a>
        <a class="mobile-nav-link" routerLink="/communities/medical-societies" (click)="closeMobileMenu()">Medical &amp; Surgical Societies</a>
        <a class="mobile-nav-link" routerLink="/communities/physician-entrepreneurs" (click)="closeMobileMenu()">Physician Entrepreneurs</a>
        <a class="mobile-nav-link" routerLink="/start-a-community" (click)="closeMobileMenu()">Start a Community</a>
        <a class="mobile-nav-link" routerLink="/pricing" (click)="closeMobileMenu()">Pricing</a>
        <a class="mobile-nav-link" routerLink="/contact" (click)="closeMobileMenu()">Contact</a>

        <h2 class="mobile-nav-heading">Resources</h2>
        <div class="mobile-nav-group">
            <a class="mobile-nav-link" routerLink="/resources" (click)="closeMobileMenu()">Resources</a>
            <a class="mobile-nav-link" routerLink="/mobile" (click)="closeMobileMenu()">Mobile app</a>
            <a class="mobile-nav-link" routerLink="/for-operators" (click)="closeMobileMenu()">For operators</a>
        </div>
        
        <div class="mobile-menu-divider"></div>
        
        <a class="mobile-nav-link mobile-nav-action primary-action" routerLink="/contact" [queryParams]="{ inquiryType: 'demo' }" (click)="onDemoCta(); closeMobileMenu()">
            <span>Book a demo</span>
            <mat-icon>arrow_forward</mat-icon>
        </a>
    </div>
</nav>
